import { EditOrderFormValues } from 'views/order-feed/features/my-supply-plan/types/edit-order-form-values.type';
import { EditOrderInput } from 'views/order-feed/features/my-supply-plan/types/edit-order-input.type';
import { formatDate, getOrderDateParts, shouldSendPlantAndVessel } from 'views/order-feed/features/my-supply-plan/utils/order-utils';

export const buildEditOrderInput = (data: EditOrderFormValues): EditOrderInput => {
  const { plantId, vessel, requestedDispatchDate } = getOrderDateParts(data.requestedDispatchDate);
  const selectedPlantId = data.plantId || plantId;
  const selectedVessel = data.vessel || vessel;

  const request: EditOrderInput = {
    orderNumber: data.orderNumber,
    transportMethod: data.transportMethod,
    requestedDispatchDate: formatDate(requestedDispatchDate),
    orderLines: data.orderLines.map((line) => ({
      itemNumber: line.itemNumber,
      orderQuantity: line.orderQuantity,
    })),
    orderComment: data.orderComment || '',
    customerOrderReference: data.customerOrderReference || '',
  };

  if (shouldSendPlantAndVessel(data.transportMethod, selectedPlantId, selectedVessel)) {
    request.plantId = selectedPlantId;
    request.vessel = selectedVessel;
  }

  return request;
};